import { toggleButtonProps, ToggleButton } from './chunk-X4HT4ZZN.js';
import { Icon } from './chunk-3QHO3DXX.js';
import { setARIALabel } from './chunk-Z6A4GYXE.js';
import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_create_component } from 'maverick.js/dom';
import { defineElement } from 'maverick.js/element';
import { volumeHighPaths, volumeLowPaths, mutePaths } from 'media-icons';

var MuteButton = class extends ToggleButton {
  constructor() {
    super(...arguments);
    this.la = "toggleMuted";
  }
  onAttach(el) {
    this.a = useMedia();
    this.u = this.U.bind(this);
    setARIALabel(el, this.F.bind(this));
    this.setAttributes({
      "data-muted": this.u,
      "data-volume": this.eg.bind(this)
    });
    super.onAttach(el);
  }
  G(event) {
    const remote = this.a.remote;
    this.u() ? remote.unmute(event) : remote.mute(event);
  }
  U() {
    const { muted, volume } = this.a.$store;
    return muted() || volume() === 0;
  }
  F() {
    return this.u() ? "Unmute" : "Mute";
  }
  eg() {
    const { muted, volume } = this.a.$store, $volume = volume();
    if (muted() || $volume === 0)
      return "muted";
    else if ($volume >= 0.5)
      return "high";
    else if ($volume < 0.5)
      return "low";
  }
  render() {
    return [
      $$_create_component(Icon, { paths: volumeHighPaths, slot: "volume-high" }),
      $$_create_component(Icon, { paths: volumeLowPaths, slot: "volume-low" }),
      $$_create_component(Icon, { paths: mutePaths, slot: "volume-muted" })
    ];
  }
};
MuteButton.el = defineElement({
  tagName: "media-mute-button",
  props: toggleButtonProps
});

export { MuteButton };
